import { render } from "./NotFound.vue?vue&type=template&id=7a2aaa04&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=7a2aaa04&scoped=true&lang=css"

import exportComponent from "D:\\WEB\\LICEO\\CURSOS\\portalalumnoscursos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a2aaa04"]])

export default __exports__